module.exports = __webpack_public_path__ + "img/element_community.67817118.svg";